/** @type {Record<string, Local.StatusAccordionProps>} */
export const REQUESTS = {
  accepted: {
    id: 'wl-accepted',
    label: 'ACCEPTED',
    className: 'accordionGreen',
    badgeClass: 'badgeGreen',
    animation: 'slideLeft',
  },
  available: {
    id: 'wl-available',
    label: 'AVAILABLE',
    className: 'accordionBlue',
    badgeClass: 'badgeBlue',
    animation: 'slideLeft',
  },
  onHold: {
    id: 'wl-onhold',
    label: 'ON HOLD',
    className: 'accordionRed',
    badgeClass: 'badgeRed',
    animation: 'slideLeft',
  },
  completed: {
    id: 'wl-completed',
    label: 'COMPLETED (LAST 3 DAYS)',
    className: 'accordionGrey',
    animation: 'slideLeft',
  },
};

/** @type {Record<string, Local.StatusAccordionProps>} */
export const QUEUES = {
  permanent: {
    id: 'q-permanent',
    label: 'PERMANENT',
    className: 'accordionWhite',
    badgeClass: 'badgeBlack',
    animation: 'slideRight',
  },
  temporary: {
    id: 'q-temporary',
    label: 'TEMPORARY',
    className: 'accordionWhite',
    badgeClass: 'badgeBlack',
    animation: 'slideRight',
  },
  available: {
    id: 'q-available',
    label: 'AVAILABLE',
    className: 'accordionWhite',
    badgeClass: 'badgeBlack',
    animation: 'slideRight',
  },
};
